exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-close[data-v-7655d097] {\n\tbackground-color: transparent;\n\tborder: 0;\n\tfloat: right;\n\tfont-size: 1.5rem;\n\tfont-weight: 700;\n\tline-height: 1;\n\tcolor: #000;\n\ttext-shadow: 0 1px 0 #fff;\n\topacity: 0.5;\n}\n.border-encoded[data-v-7655d097] {\n\tborder: 2px solid #cad0d7;\n\tborder-radius: 5px;\n}\n", ""]);

// exports
